import { useOAuth } from '@novafuturltd/core'
import React, { FC } from 'react'
import { mayPerform } from './shared/access'
import type { AvatarBoPermission } from './shared/permissions'

export interface AvatarBoCanProps {
  perform?: AvatarBoPermission
  /** Any ONE of these is enough. A screen two roles reach needs the union, not a second gate. */
  anyOf?: AvatarBoPermission[]
  yes?: () => React.ReactElement | null
  no?: () => React.ReactElement | null
}

const AvatarBoCan: FC<AvatarBoCanProps> = ({
  perform,
  anyOf,
  yes = () => null,
  no = () => null,
}) => {
  const { permissions, tokenData } = useOAuth()
  const wanted = anyOf ?? (perform ? [perform] : [])
  const allowed = wanted.some((p) =>
    mayPerform({
      permissions,
      accessToken: tokenData?.access_token,
      perform: p,
    }),
  )

  return allowed ? yes() : no()
}

export default AvatarBoCan
